import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetAssignedTenantsItem } from '../../../../service/proxy';

@Component({
    selector: 'tenant-selection-panel',
    templateUrl: './tenant-selection-panel.component.html',
    styleUrls: ['./tenant-selection-panel.component.scss'],
    imports: [CommonModule],
})
export class TenantSelectionPanelComponent {
    @Input()
    tenants: GetAssignedTenantsItem[] | null = null;

    @Output()
    tenantSelected = new EventEmitter<number>();

    @Output()
    tenantModalClosed = new EventEmitter<void>();

    public header: string = 'Select Tenant'

    selectTenant(event: Event, tenantId: number): void {
        event.preventDefault();
        this.tenantSelected.emit(tenantId);
    }

    closeModal(): void {
        this.tenantModalClosed.emit();
    }
}